export default "__VITE_ASSET__Nm8BOZlo__"